import script from "./userAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./userAdd.vue?vue&type=script&setup=true&lang=js"

import "./userAdd.vue?vue&type=style&index=0&id=2f9f334c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f9f334c"]])

export default __exports__